export const GdprApiUrl = import.meta.env.VITE_GDPR_API_URL;
